import React, { useEffect, useRef, useState } from "react";
import {
  Stack,
  TextField,
  Typography,
  Button,
  IconButton,
  Checkbox,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";

import { useNavigate } from "react-router-dom";
import { checkUserLoggedIn } from "../../shared/commonfunctions";
import { Formik, Form, FieldArray } from "formik";
import {
  startOverAPICall,
  stageDetailsAPICall,
  nomineeAPICall,
  CommonDropDownAPICall,
} from "../../shared/APICalls";
import { schema } from "../../shared/FormikSchema";
import StageLayout from "../../Layouts/StageLayout";
import routesData from "../../shared/routes.json";
import Styles from "../../pages/Styles/NomineeStyles.module.scss";
import { INominee } from "../../shared/dtos";
import icon from "../../Components/assets/Images/iconnew.svg";
import NomineeForm from "./NomineeForm";
import StartOverBackDrop from "../../Components/StartOverBackDrop";
import BackDrop from "../../Components/BackDrop";
import { v4 as uuidv4 } from "uuid";
import dayjs, { Dayjs } from "dayjs";
import { nomineeID } from "../../shared/commonData";
import ErrorSnackBar from "../../Components/SnackBars/ErrorSnackBar";
import StageLayoutEkyc from "../../Layouts/StageLayoutEkyc";
import { confirmAlert } from "react-confirm-alert";
import keyboardicon from "../../Components/assets/Images/nomineeicongrey.svg";
import AddBoxOutlinedIcon from "@mui/icons-material/AddBoxOutlined";
import backicon from "../../Components/assets/Images/back.svg";
import {
  setCompletedStages,
  setCurrentStage,
} from "../../Components/redux/actions/pathNameActions";
import { useDispatch } from "react-redux";
import SnackBar from "../../Components/SnackBars/SnackBar";
import TagManager from "react-gtm-module";
import ProgressComp from "../../Components/ProgressComp/ProgressComp";
import DoneIcon from "@mui/icons-material/Done";
import NomineeDeclarationModal from "../../Components/Modals/NomineeDeclarationModal/NomineeDeclarationModal";
import SideBar from "../../Components/SideBar/SideBar";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import NomineeBar from "./NomineeBar";
import trash from "../../Components/assets/Images/trash.svg";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import MenuIcon from "@mui/icons-material/Menu";
import ProgressBar from "../../Components/ProgressBar/ProgressBar";
import ControlPointIcon from "@mui/icons-material/ControlPoint";

const statesData = [
  {
    id: "Jammu and Kashmir",
    sequence: 1,
    value: "Jammu and Kashmir",
  },
  {
    id: "Himachal Pradesh",
    sequence: 2,
    value: "Himachal Pradesh",
  },
  {
    id: "Punjab",
    sequence: 3,
    value: "Punjab",
  },
  {
    id: "Chandigarh",
    sequence: 4,
    value: "Chandigarh",
  },
  {
    id: "Uttarakhand",
    sequence: 5,
    value: "Uttarakhand",
  },
  {
    id: "Haryana",
    sequence: 6,
    value: "Haryana",
  },
  {
    id: "Delhi",
    sequence: 7,
    value: "Delhi",
  },
  {
    id: "Rajasthan",
    sequence: 8,
    value: "Rajasthan",
  },
  {
    id: "Uttar Pradesh",
    sequence: 9,
    value: "Uttar Pradesh",
  },
  {
    id: "Bihar",
    sequence: 10,
    value: "Bihar",
  },
  {
    id: "Sikkim",
    sequence: 11,
    value: "Sikkim",
  },
  {
    id: "Arunachal Pradesh",
    sequence: 12,
    value: "Arunachal Pradesh",
  },
  {
    id: "Assam",
    sequence: 13,
    value: "Assam",
  },
  {
    id: "Manipur",
    sequence: 14,
    value: "Manipur",
  },
  {
    id: "Mizoram",
    sequence: 15,
    value: "Mizoram",
  },
  {
    id: "Tripura",
    sequence: 16,
    value: "Tripura",
  },
  {
    id: "Meghalaya",
    sequence: 17,
    value: "Meghalaya",
  },
  {
    id: "Nagaland",
    sequence: 18,
    value: "Nagaland",
  },
  {
    id: "West Bengal",
    sequence: 19,
    value: "West Bengal",
  },
  {
    id: "Jharkhand",
    sequence: 20,
    value: "Jharkhand",
  },
  {
    id: "Orissa",
    sequence: 21,
    value: "Orissa",
  },
  {
    id: "Chhattisgarh",
    sequence: 22,
    value: "Chhattisgarh",
  },
  {
    id: "Madhya Pradesh",
    sequence: 23,
    value: "Madhya Pradesh",
  },
  {
    id: "Gujarat",
    sequence: 24,
    value: "Gujarat",
  },
  {
    id: "Daman and Diu",
    sequence: 25,
    value: "Daman and Diu",
  },
  {
    id: "Dadra and Nagar Haveli",
    sequence: 26,
    value: "Dadra and Nagar Haveli",
  },
  {
    id: "Maharashtra",
    sequence: 27,
    value: "Maharashtra",
  },
  {
    id: "Andhra Pradesh",
    sequence: 28,
    value: "Andhra Pradesh",
  },
  {
    id: "Karnataka",
    sequence: 29,
    value: "Karnataka",
  },
  {
    id: "Goa",
    sequence: 30,
    value: "Goa",
  },
  {
    id: "Lakshadweep",
    sequence: 31,
    value: "Lakshadweep",
  },
  {
    id: "Kerala",
    sequence: 32,
    value: "Kerala",
  },
  {
    id: "Tamil Nadu",
    sequence: 33,
    value: "Tamil Nadu",
  },
  {
    id: "Puducherry",
    sequence: 34,
    value: "Puducherry",
  },
  {
    id: "Andaman and Nicobar Islands",
    sequence: 35,
    value: "Andaman and Nicobar Islands",
  },
  {
    id: "APO",
    sequence: 36,
    value: "APO",
  },
  {
    id: "Telangana",
    sequence: 37,
    value: "Telangana",
  },
  {
    id: "Ladakh",
    sequence: 38,
    value: "Ladakh",
  },
];

export default function NomineesPage() {
  const dispatch = useDispatch();
  const [addNominee, setAddNominee] = useState(false);
  const [address, setaddress] = useState({
    address: " ",
    city: "",
    pincode: "",
    State: "",
  });
  const navigate = useNavigate();
  //   const [percentageTotal, setPercentageTotal] = useState(0);
  const [assignIndex, setAssignIndex] = useState(0);
  const [relationShipData, setRelationShipData] = useState<any>([]);
  const [loading, setloading] = useState(false);
  const [startOverloading, setstartOverloading] = useState(false);
  const [ageError, setageError] = useState(false);
  const [gaurdianData, setgaurdianData] = useState(false);
  const [relationError, setrelationError] = useState(false);
  const [dobError, setDobError] = useState("");
  const [backdrop, setBackDrop] = useState(false);
  const [prefilloading, setprefilloading] = useState(true);
  const [rejectMessage, setRejectMessage] = useState("");
  const [prefillData, setPrefillData] = useState<any>([
    {
      id: uuidv4(),
      nomineeFullName: "",
      nomineeEmail: "",
      nomineeAddress: "",
      nomineeDateofBirth: null,
      nomineeMobileNumber: "",
      percentageofShare: "100",
      relationShip: "",
      relationshipIfOthers: "",
      gaurdianFirstName: "",
      gaurdianLastName: "",
      gaurdianDateofBirth: "",
      gaurdianEmail: "",
      gaurdianMobileNumber: "",
      gaurdianRelationWithNominee: "",
      gaurdianAddress: "",
      gaurdianAddressPinCode: "",
      gaurdianAddressCity: "",
      gaurdianAddressState: "",
      nomineeIDProof: "",
      nomineeIDProofNo: "",
      nomineeAddressCity: "",
      nomineeAddressPinCode: "",
      nomineeAddressState: "",
    },
  ]);
  const [customerEmail, setCustomerEmail] = useState("");
  const [customerPhoneNumber, setCustomerPhoneNumber] = useState("");
  const [message, setMessage] = useState("");
  const [openModal, setopenModal] = useState(false);
  const [expandMenu, setExpandMenu] = useState<any>(false);
  const [showNomineeAdditionalDetails, setShowNomineeAdditionalDetails] =
    useState<Record<number, boolean>>({});
  const navigationData = routesData;

  const getSystemTheme = () =>
    window.matchMedia("(prefers-color-scheme: dark)").matches
      ? "dark"
      : "light";
  const [mode, setMode] = useState(getSystemTheme());

  useEffect(() => {
    setMode(getSystemTheme());
  }, [getSystemTheme]);

  // console.log("assignIndex", assignIndex);

  const convertDayJsToDate = (dateValue: any) => {
    const date = new Date(dateValue);

    const formattedDate = date.toLocaleDateString("en-GB", {
      year: "numeric",
      day: "2-digit",
      month: "2-digit",
    });
    const [month, day, year] = formattedDate.split("/");
    const formatDate = `${year}-${day}-${month}`;
    return formatDate;
  };

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);
    checkUserLoggedIn(navigate);
    let dd_type = "nominee";
    CommonDropDownAPICall(dd_type)
      .then((response: any) => {
        const relationshipDataTemp = response.data.data.nominee_relation;
        //console.log("responseData", responseData);
        setRelationShipData([...relationshipDataTemp]);
        let obj: any = {
          stage: "nominee",
        };

        stageDetailsAPICall(obj)
          .then((response: any) => {
            const responseData = response.data;
            dispatch(setCompletedStages(responseData.data.completed_stages));
            dispatch(setCurrentStage(responseData.data.current_stage));
            // console.log("responseData", responseData);
            if (response?.data?.data?.ErrorMessage) {
              setRejectMessage(response.data.data.ErrorMessage);
            }

            setprefilloading(false);
            const addr = responseData?.data?.data?.nominee_prifill?.address
              ? responseData?.data?.data?.nominee_prifill?.address
              : "";
            const city = responseData?.data?.data?.nominee_prifill?.city
              ? responseData?.data?.data?.nominee_prifill?.city
              : "";
            const state = responseData?.data?.data?.nominee_prifill?.state
              ? responseData?.data?.data?.nominee_prifill?.state
              : "";
            const pincode = responseData?.data?.data?.nominee_prifill?.pincode
              ? responseData?.data?.data?.nominee_prifill?.pincode
              : "";
            const clientEmail = responseData?.data?.data?.nominee_prifill?.email
              ? responseData?.data?.data?.nominee_prifill?.email
              : "";
            const clientMobile = responseData?.data?.data?.nominee_prifill
              ?.mobile
              ? responseData?.data?.data?.nominee_prifill?.mobile
              : "";
            setCustomerEmail(clientEmail);
            setCustomerPhoneNumber(clientMobile);
            setPrefillData([
              {
                id: uuidv4(),
                nomineeFullName: "",
                nomineeEmail: clientEmail,
                nomineeAddress: "",
                nomineeDateofBirth: null,
                nomineeMobileNumber: clientMobile,
                percentageofShare: "100",
                relationShip: "",
                relationshipIfOthers: "",
                gaurdianFirstName: "",
                gaurdianlastName: "",
                gaurdianDateofBirth: "",
                gaurdianEmail: "",
                gaurdianMobileNumber: "",
                gaurdianRelationWithNominee: "",
                gaurdianAddress: "",
                gaurdianAddressPinCode: "",
                gaurdianAddressCity: "",
                gaurdianAddressState: "",
                nomineeIDProof: "",
                nomineeIDProofNo: "",
                nomineeAddressCity: "",
                nomineeAddressPinCode: "",
                nomineeAddressState: "",
              },
            ]);

            setaddress({
              address: addr.toUpperCase(),
              city: city.toUpperCase(),
              pincode: pincode.toUpperCase(),
              State: state.toUpperCase(),
            });
            // console.log(responseData.data.StageDetails.NomineeDetails.length)

            if (
              responseData?.data?.data?.nominee_details &&
              responseData?.data?.data?.nominee_details[0]
            ) {
              // console.log(
              //   "responseData?.data?.data?.nominee_details[0]",
              //   responseData?.data?.data?.nominee_details[0],
              // );
              setAddNominee(true);
            }

            if (
              responseData?.data?.data?.nominee_details &&
              responseData?.data?.data?.nominee_details[0]?.FullName !== ""
            ) {
              let nomineeDetails =
                responseData?.data?.data?.nominee_details?.map(
                  (data: any, index: number) => ({
                    id: data.id,
                    nomineeFullName: data?.FullName,
                    nomineeEmail: data?.Email,
                    nomineeAddress: data?.Address,
                    nomineeDateofBirth: dayjs(data.DOB),
                    nomineeMobileNumber: data?.Mobile,
                    percentageofShare: data?.SharePercentage,
                    relationShip: relationshipDataTemp.find(
                      (a: any) => a?.value === data?.Relationship,
                    ),
                    relationshipIfOthers: !data.RelationshipOthersValue
                      ? ""
                      : data.RelationshipOthersValue,
                    gaurdianFirstName: !data.GaurdianFirstName
                      ? ""
                      : data.GaurdianFirstName,
                    gaurdianLastName: !data.GaurdianLastName
                      ? ""
                      : data.GaurdianLastName,
                    gaurdianDateofBirth: !data.GuradianDOB
                      ? ""
                      : dayjs(data.GuradianDOB),
                    gaurdianEmail: !data.GuradianEmail
                      ? ""
                      : data.GuradianEmail,
                    gaurdianMobileNumber: !data.GuradianMobile
                      ? ""
                      : data.GuradianMobile,
                    gaurdianRelationWithNominee:
                      !data.GuradianRealtionWithNominee
                        ? ""
                        : relationshipDataTemp.find(
                            (a: any) =>
                              a.value.toUpperCase() ===
                              data.GuradianRealtionWithNominee.toUpperCase(),
                          ),
                    gaurdianRelationOthers: !data.GuradianRelationOthers
                      ? ""
                      : data.GuradianRelationOthers,
                    gaurdianAddress: !data.GuradianAddress
                      ? ""
                      : data.GuradianAddress,
                    gaurdianAddressPinCode: !data.GuradianAddressPinCode
                      ? ""
                      : data.GuradianAddressPinCode,
                    gaurdianAddressCity: !data.GuradianAddressCity
                      ? ""
                      : data.GuradianAddressCity,

                    gaurdianAddressState: !data.GuradianAddressState
                      ? ""
                      : statesData.filter(
                          (a: any) =>
                            a.value?.toUpperCase() ===
                            data.GuradianAddressState.toUpperCase(),
                        )[0],
                    nomineeIDProof: nomineeID.filter(
                      (a: any) => a === data.NomineeIDProof,
                    )[0],
                    nomineeIDProofNo: !data.NomineeIDProofNo
                      ? ""
                      : data.NomineeIDProofNo,
                    nomineeAddressPinCode: data.Pincode,
                    nomineeAddressCity: data.City,
                    nomineeAddressState: statesData.filter(
                      (a: any) =>
                        a.value.toUpperCase() === data.State.toUpperCase(),
                    )[0],
                  }),
                );
              setPrefillData(nomineeDetails);
              // console.log("relationshipDataTemp", relationshipDataTemp);
            }
          })
          .catch((error: any) => {
            //console.log("error", error);
            setprefilloading(false);
          });
      })
      .catch((error: any) => {});
    setprefilloading(true);
  }, []);

  const handleNomineeAdd = (
    values: any,
    callBack: any,
    setFieldTouched: any,
  ) => {
    setFieldTouched("nomineeFullName", false);
    setFieldTouched("nomineeEmail", false);
    setFieldTouched("nomineeAddress", false);
    setFieldTouched("nomineeDateofBirth", false);
    setFieldTouched("nomineeMobileNumber", false);
    setFieldTouched("percentageofShare", false);
    setFieldTouched("relationShip", false);
    setFieldTouched("relationshipIfOthers", false);
    setFieldTouched("gaurdianFirstName", false);
    setFieldTouched("gaurdianLastName", false);
    setFieldTouched("gaurdianDateofBirth", false);
    setFieldTouched("gaurdianEmail", false);
    setFieldTouched("gaurdianMobileNumber", false);
    setFieldTouched("gaurdianRelationWithNominee", false);
    setFieldTouched("nomineeIDProof", false);
    setFieldTouched("nomineeIDProofNo", false);
    setFieldTouched("nomineeAddressCity", false);
    setFieldTouched("nomineeAddressPinCode", false);
    setFieldTouched("nomineeAddressState", false);
    setAssignIndex((prev) => prev + 1);
    const obj: INominee = {
      id: uuidv4(),
      nomineeFullName: "",
      nomineeEmail: customerEmail,
      nomineeAddress: "",
      nomineeDateofBirth: null,
      nomineeMobileNumber: customerPhoneNumber,
      percentageofShare: "",
      relationShip: "",
      relationshipIfOthers: "",
      gaurdianFirstName: "",
      gaurdianLastName: "",
      gaurdianDateofBirth: "",
      gaurdianEmail: "",
      gaurdianMobileNumber: "",
      gaurdianRelationWithNominee: "",
      nomineeIDProof: "",
      nomineeIDProofNo: "",
      nomineeAddressCity: "",
      nomineeAddressPinCode: "",
      nomineeAddressState: "",
    };

    const nomineeCopy: any = [...values.nominees];
    nomineeCopy.push(obj);
    callBack("nominees", nomineeCopy);
  };

  const handleNomineeDelete = (values: any, callBack: any, index: any) => {
    const nomineeCopy: any = [...values.nominees];
    nomineeCopy.splice(index, 1);
    callBack("nominees", nomineeCopy);
    setAssignIndex(index - 1);
  };
  const handleChangeField = (
    name: any,
    value: any,
    callBack: any,
    index: any,
    values: any,
    setErrors: any,
    errors: any,
  ) => {
    let nomineeCopy: any = [...values.nominees];
    nomineeCopy[index][name] = value;
    callBack("nominees", nomineeCopy);
    if (name === "nomineeDateofBirth") {
      if (
        values.nominees[index].nomineeDateofBirth &&
        values.nominees[index].relationShip &&
        !values.nominees[index].relationShip.isGuardianReq
      ) {
        const dobLimit = new Date();
        dobLimit.setFullYear(dobLimit.getFullYear() - 18);
        if (
          !values.nominees[index].nomineeDateofBirth ||
          values.nominees[index].nomineeDateofBirth > dobLimit
        ) {
          // console.log("DOB is not 18 years");
        }
      }
    }
    if (name === "relationShip") {
      // Clearing Others Data
      if (
        value.value !== "Others" &&
        nomineeCopy[index]["relationshipIfOthers"]
      ) {
        nomineeCopy[index]["relationshipIfOthers"] = "";
        callBack("nominees", nomineeCopy);
      }
      if (
        values.nominees[index].nomineeDateofBirth &&
        values.nominees[index].relationShip &&
        !values.nominees[index].relationShip.isGuardianReq
      ) {
        const dobLimit = new Date();
        dobLimit.setFullYear(dobLimit.getFullYear() - 18);
        if (
          !values.nominees[index].nomineeDateofBirth ||
          values.nominees[index].nomineeDateofBirth > dobLimit
        ) {
          // console.log("DOB is not 18 years");
        }
      }
    }

    if (name === "nomineeFullName") {
      const currentRelationShip = values.nominees[index].nomineeFullName;

      const isDuplicateRelationship = values.nominees.some((nominee, i) => {
        if (i !== index && nominee.nomineeFullName === currentRelationShip) {
          return true;
        }
        return false;
      });

      if (isDuplicateRelationship) {
        setrelationError(true);

        setTimeout(() => {
          setrelationError(false);
        }, 8000);
      }
    }
    if (name === "gaurdianDateofBirth") {
      const dobLimit = new Date();
      dobLimit.setFullYear(dobLimit.getFullYear() - 18);
      if (!value || value > dobLimit) {
        // setDobError(true);

        setDobError("Gaurdian Age should not be Below 18");
        setTimeout(() => {
          setDobError("");
        }, 10000);
      }
    }
  };

  const handleStartOver = () => {
    confirmAlert({
      title: "",
      message:
        "Are you sure you want to restart, on pressing Yes all the Data will be deleted",
      buttons: [
        {
          label: "No",
          onClick: () => "",
        },
        {
          label: "Yes",
          onClick: () => {
            setBackDrop(true);
            setstartOverloading(true);
            startOverAPICall()
              .then((response: any) => {
                const responseData = response.data;

                setstartOverloading(false);
                setBackDrop(false);
                navigate("/");
                window.location.reload();
              })
              .catch((error: any) => {
                setBackDrop(false);
                setstartOverloading(false);
              });
          },
        },
      ],
    });
  };

  const handleNomineeEdit = (index: any) => {
    setAssignIndex(index);
  };

  const checkAgeLimit = (enteredDate: any) => {
    const dobLimit = new Date();
    dobLimit.setFullYear(dobLimit.getFullYear() - 18);
    if (!enteredDate || enteredDate > dobLimit) {
      return true;
    } else {
      return false;
    }
  };

  const handleClose = () => {
    setopenModal(false);
  };

  function nomineeDetailsSubmit(values: any) {
    // let ArrayObject = values.map((a: any) => ({
    //   id: a.id,
    //   FullName: a.nomineeFullName.toUpperCase().trim(),
    //   Email: "",
    //   Address: "",
    //   DOB: convertDayJsToDate(a.nomineeDateofBirth),
    //   Mobile: "",
    //   SharePercentage: a.percentageofShare,
    //   Relationship: a.relationShip.value,
    //   RelationshipName: a.relationShip.value.toUpperCase(),
    //   RelationshipOthersValue: a.relationshipIfOthers
    //     ? a.relationshipIfOthers.toUpperCase().trim()
    //     : "",
    //   GuradianFullName: checkAgeLimit(new Date(a.nomineeDateofBirth))
    //     ? a.gaurdianFirstName
    //       ? `${a.gaurdianFirstName.toUpperCase().trim()} ${a.gaurdianLastName.toUpperCase().trim()}`
    //       : ""
    //     : "",
    //   GaurdianFirstName: checkAgeLimit(new Date(a.nomineeDateofBirth))
    //     ? a.gaurdianFirstName
    //       ? a.gaurdianFirstName.toUpperCase().trim()
    //       : ""
    //     : "",
    //   GaurdianLastName: checkAgeLimit(new Date(a.nomineeDateofBirth))
    //     ? a.gaurdianLastName
    //       ? a.gaurdianLastName.toUpperCase().trim()
    //       : ""
    //     : "",
    //   GuradianDOB: "",
    //   GuradianEmail: "",
    //   GuradianMobile: "",
    //   GuradianRealtionWithNominee: checkAgeLimit(new Date(a.nomineeDateofBirth))
    //     ? a.gaurdianRelationWithNominee.value
    //       ? a.gaurdianRelationWithNominee.value.toUpperCase()
    //       : ""
    //     : "",
    //   GuradianRelationOthers: "",
    //   GuradianAddress: "",
    //   GuradianAddressPinCode: "",
    //   GuradianAddressCity: "",
    //   GuradianAddressState: "",
    //   NomineeIDProof: "",
    //   NomineeIDProofNo: "",
    //   Pincode: "",
    //   City: "",
    //   State: "",
    // }));

    // console.log("values",values)

    let ArrayObject = values.map((a: any) => ({
      id: a.id,
      FullName: a.nomineeFullName.toUpperCase().trim(),
      Email: a.nomineeEmail || "",
      Address: (a.nomineeAddress || "").toUpperCase().trim(),
      DOB: convertDayJsToDate(a.nomineeDateofBirth),
      Mobile: a.nomineeMobileNumber || "",
      SharePercentage: a.percentageofShare,
      Relationship: a.relationShip.value,
      RelationshipName: a.relationShip.value.toUpperCase(),
      RelationshipOthersValue: a.relationshipIfOthers
        ? a.relationshipIfOthers.toUpperCase().trim()
        : "",
      GuradianFullName: checkAgeLimit(new Date(a.nomineeDateofBirth))
        ? a.gaurdianFirstName
          ? `${a.gaurdianFirstName.toUpperCase().trim()} ${(a.gaurdianLastName || "").toUpperCase().trim()}`
          : ""
        : "",
      GaurdianFirstName: checkAgeLimit(new Date(a.nomineeDateofBirth))
        ? a.gaurdianFirstName
          ? a.gaurdianFirstName.toUpperCase().trim()
          : ""
        : "",
      GaurdianLastName: checkAgeLimit(new Date(a.nomineeDateofBirth))
        ? a.gaurdianLastName
          ? a.gaurdianLastName.toUpperCase().trim()
          : ""
        : "",
      GuradianDOB: a.nomineeDateofBirth
        ? checkAgeLimit(new Date(a.nomineeDateofBirth))
          ? a.gaurdianDateofBirth
            ? convertDayJsToDate(a.gaurdianDateofBirth)
            : ""
          : ""
        : "",
      GuradianEmail: checkAgeLimit(new Date(a.nomineeDateofBirth))
        ? a.gaurdianEmail || ""
        : "",
      GuradianMobile: checkAgeLimit(new Date(a.nomineeDateofBirth))
        ? a.gaurdianMobileNumber || ""
        : "",
      GuradianRealtionWithNominee: checkAgeLimit(new Date(a.nomineeDateofBirth))
        ? a.gaurdianRelationWithNominee?.value
          ? a.gaurdianRelationWithNominee.value.toUpperCase()
          : ""
        : "",
      GuradianRelationOthers: checkAgeLimit(new Date(a.nomineeDateofBirth))
        ? a.gaurdianRelationOthers
          ? a.gaurdianRelationOthers.toUpperCase()
          : ""
        : "",
      GuradianAddress: checkAgeLimit(new Date(a.nomineeDateofBirth))
        ? a.gaurdianAddress
          ? a.gaurdianAddress.toUpperCase().trim() || ""
          : ""
        : "",
      GuradianAddressPinCode: checkAgeLimit(new Date(a.nomineeDateofBirth))
        ? a.gaurdianAddressPinCode || ""
        : "",
      GuradianAddressCity: checkAgeLimit(new Date(a.nomineeDateofBirth))
        ? a.gaurdianAddressCity
          ? a.gaurdianAddressCity.toUpperCase().trim() || ""
          : ""
        : "",
      GuradianAddressState: checkAgeLimit(new Date(a.nomineeDateofBirth))
        ? a.gaurdianAddressState?.value
          ? a.gaurdianAddressState.value.toUpperCase()
          : ""
        : "",
      NomineeIDProof: !a.nomineeIDProof ? "" : a.nomineeIDProof,
      NomineeIDProofNo: (a.nomineeIDProofNo || "").toUpperCase(),
      Pincode: a.nomineeAddressPinCode || "",
      City: (a.nomineeAddressCity || "").toUpperCase().trim(),
      State: (a.nomineeAddressState?.value || "").toUpperCase(),
    }));
    // console.log("date", checkAgeLimit(new Date("2000-01-01")));
    // console.log("valuesAfter", ArrayObject);
    let obj: any = {
      nominee_json: ArrayObject,
    };

    nomineeAPICall(obj)
      .then((response: any) => {
        const responseData = response.data;
        //  console.log("responseData", responseData);
        setloading(false);
        if (
          responseData.data.next_stage &&
          navigationData.hasOwnProperty(responseData.data.next_stage)
        ) {
          navigate(navigationData[responseData.data.next_stage]);
        }
      })
      .catch((error: any) => {
        setloading(false);
        setMessage(error?.response?.data?.message);
        setTimeout(() => {
          setMessage("");
        }, 5000);
      });
  }
  const handleSkipNominee = () => {
    let obj: any = {
      nominee_json: [],
    };
    nomineeAPICall(obj)
      .then((response: any) => {
        const responseData = response.data;
        //  console.log("responseData", responseData);
        setloading(false);
        if (
          responseData.data.next_stage &&
          navigationData.hasOwnProperty(responseData.data.next_stage)
        ) {
          navigate(navigationData[responseData.data.next_stage]);
        }
      })
      .catch((error: any) => {
        setloading(false);
        setMessage(
          error?.response?.data?.message
            ? error?.response?.data?.message
            : "Error Occured",
        );
        setTimeout(() => {
          setMessage("");
        }, 5000);
      });
  };

  return (
    <>
      <ErrorSnackBar message={rejectMessage} />
      {backdrop && <StartOverBackDrop />}
      <SnackBar message={message} />
      <div className={Styles.layout}>
        <div className={Styles.sidebar}>
          <SideBar />
        </div>
        <div className={Styles.pageContent}>
          <div className={Styles.mainWrapperTop}>
            <div className={Styles.headerSection}>
              <p className={Styles.signup}>
                <div
                  className={Styles.mobileBack}
                  onClick={() => {
                    if (!addNominee) {
                      navigate("/ipv");
                    } else {
                      setAddNominee(false);
                    }
                  }}
                >
                  <ArrowBackIosIcon />
                </div>
                {addNominee ? "Add" : ""} Nominee Details
                <div
                  className={Styles.mobileMenu}
                  onClick={() => {
                    setExpandMenu(!expandMenu);
                  }}
                >
                  {expandMenu ? <CloseIcon /> : <MenuIcon />}
                </div>
              </p>
              <ProgressBar />
              <div
                className={Styles.mobileexpandedMenu}
                style={{
                  height: expandMenu ? "100%" : "0%",
                }}
              >
                <div className={Styles.mobilemenuContent}>
                  <SideBar />
                </div>
              </div>
              {!addNominee && (
                <p className={Styles.almostthere}>Almost There!</p>
              )}
            </div>

            {!addNominee ? (
              <div className={Styles.MainSection}>
                <div className={Styles.MainSectionContainer}>
                  <p className={Styles.MainSectionText}>
                    <DoneIcon style={{ color: "#049981", fontSize: "20px" }} />{" "}
                    You can add up to three nominees to your account.
                  </p>
                  <p className={Styles.MainSectionText}>
                    <DoneIcon style={{ color: "#049981", fontSize: "20px" }} />{" "}
                    Guardian details are required if the nominee is a minor.
                  </p>
                </div>

                <div className={Styles.MainSectionButtons}>
                  <Button
                    variant="text"
                    sx={{
                      color: "var(--ds-text-primary)",
                      gap: "8px",
                    }}
                    onClick={() => {
                      navigate("/ipv");
                    }}
                    className={Styles.backbutton}
                  >
                    <KeyboardBackspaceIcon /> Back
                  </Button>
                  <LoadingButton
                    variant="contained"
                    type="submit"
                    onClick={() => {
                      setAddNominee(true);
                    }}
                    // sx={{
                    //   color: "var(--ds-text-primary)",
                    //   background: "var(--ds-bg)",
                    //   border: "1px solid var(--ds-outline)",
                    // }}
                    loading={loading}
                    id="nomineesContinueButton"
                    className={Styles.continue}
                  >
                    Add Nominee
                  </LoadingButton>

                  {/* <LoadingButton
                    variant="contained"
                    type="submit"
                    onClick={() => {
                      setopenModal(true);
                    }}
                    id="nomineesContinueButton"
                    className={Styles.continue}
                  >
                    Skip & Continue
                  </LoadingButton> */}
                </div>
              </div>
            ) : (
              <>
                {!prefilloading ? (
                  <Formik
                    validationSchema={schema}
                    initialValues={{
                      nominees: [...prefillData],
                    }}
                    onSubmit={(values: any) => {
                      // console.log("submit", values.nominees);
                      nomineeDetailsSubmit(values.nominees);
                    }}
                  >
                    {({
                      values,
                      errors,
                      touched,
                      handleChange,
                      handleBlur,
                      handleSubmit,
                      setFieldValue,
                      setFieldError,
                      setErrors,
                      setFieldTouched,
                      setTouched,
                    }) => {
                      const { nominees } = values;
                      // console.log("errors", errors);
                      // console.log("nominees", nominees);

                      const percentageTotal = values.nominees
                        .map((a: any) =>
                          a.percentageofShare === ""
                            ? 0
                            : parseFloat(a.percentageofShare),
                        )
                        .reduce((sum: any, current: any) => sum + current, 0);
                      // console.log("values", values);
                      return (
                        <Form style={{ width: "100%" }}>
                          <div className={Styles.mobileNomineeTabs}>
                            <div className={Styles.buttonSectionTop}>
                              {nominees?.map((nominee: any, index: any) => (
                                <div
                                  onClick={() => {
                                    handleNomineeEdit(index);
                                  }}
                                  className={Styles.nomineesAdded}
                                  style={{
                                    background:
                                      index === assignIndex
                                        ? "var(--ds-card)"
                                        : "",
                                    border:
                                      index === assignIndex
                                        ? "1px solid var(--ds-text-primary)"
                                        : "",
                                  }}
                                >
                                  Nominee {index + 1}
                                </div>
                              ))}
                            </div>

                            {nominees?.length !== 3 ? (
                              <Button
                                variant="text"
                                className={Styles.addNomineeButtonMobile}
                                onClick={() => {
                                  handleNomineeAdd(
                                    values,
                                    setFieldValue,
                                    setFieldTouched,
                                  );
                                  window.scrollTo(0, 0);
                                }}
                                disabled={
                                  percentageTotal >= 100 ||
                                  assignIndex === 2 ||
                                  Object.keys(errors).length > 0 ||
                                  Object.keys(touched).length === 0
                                }
                                id="nomineesAddNomineeButton"
                                sx={{
                                  width: "20px",
                                  height: "20px !important",
                                  minWidth: "20px",
                                  color: "var(--ds-text-primary)",
                                  fontSize: "12px",
                                  padding: "0px",
                                  visibility:
                                    assignIndex !== 2 ? "visible" : "hidden",
                                }}
                                size="small"
                              >
                                <ControlPointIcon />
                              </Button>
                            ) : (
                              ""
                            )}
                          </div>
                          <div className={Styles.wrapper}>
                            <div className={Styles.leftContainer}>
                              <div style={{ width: "100%" }}>
                                <p className={Styles.Header}>
                                  {assignIndex === 0
                                    ? "Nominee Details"
                                    : `Nominee Details ${assignIndex + 1}`}
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      marginLeft: "auto",
                                    }}
                                  >
                                    <Checkbox
                                      size="small"
                                      checked={Boolean(
                                        showNomineeAdditionalDetails[
                                          assignIndex
                                        ],
                                      )}
                                      onChange={(event) => {
                                        setShowNomineeAdditionalDetails(
                                          (current) => ({
                                            ...current,
                                            [assignIndex]: event.target.checked,
                                          }),
                                        );
                                      }}
                                    />
                                    <span style={{ fontSize: "12px" }}>
                                      Add Additional Details
                                    </span>
                                  </div>
                                  {nominees?.length > 1 &&
                                    assignIndex !== 0 && (
                                      <div
                                        onClick={() => {
                                          // handleNomineeDelete(assignIndex);
                                          handleNomineeDelete(
                                            values,
                                            setFieldValue,
                                            assignIndex,
                                          );
                                        }}
                                        title="Delete Nominee"
                                        id="nomineesDeleteNomineeButton"
                                        style={{
                                          cursor: "pointer",
                                          height: "20px",
                                          marginLeft: "12px",
                                        }}
                                      >
                                        <img
                                          src={trash}
                                          style={{ width: "18px" }}
                                        />
                                      </div>
                                    )}
                                </p>
                              </div>
                              <FieldArray
                                name="nominees"
                                render={(arrayHelpers) => (
                                  <div style={{ width: "100%" }}>
                                    {nominees.map((nominee, index) => {
                                      const touchedData =
                                        touched?.nominees?.[index] || {};
                                      const errorData = errors.nominees
                                        ? errors.nominees[index]
                                        : {};

                                      // console.log("touchedData", touched);
                                      // console.log("errorData", errorData);

                                      return (
                                        <NomineeForm
                                          handleNomineeDelete={
                                            handleNomineeDelete
                                          }
                                          handleNomineeEdit={handleNomineeEdit}
                                          index={index}
                                          currentIndex={assignIndex}
                                          nominee={nominee}
                                          touchedData={touched}
                                          errorData={errorData}
                                          handleChangeField={handleChangeField}
                                          setFieldValue={setFieldValue}
                                          values={values}
                                          handleBlur={handleBlur}
                                          relationError={false}
                                          ageError={false}
                                          relationShipData={relationShipData}
                                          address={address}
                                          setErrors={setErrors}
                                          errors={errors}
                                          gaurdianData={gaurdianData}
                                          statesData={statesData}
                                          setTouched={setTouched}
                                          touched={touched}
                                          nominees={nominees}
                                          mode={mode}
                                          showAdditionalDetails={Boolean(
                                            showNomineeAdditionalDetails[index],
                                          )}
                                        />
                                      );
                                    })}
                                  </div>
                                )}
                              />
                            </div>

                            <div
                              className={Styles.buttonSection}
                              style={{
                                justifyContent:
                                  nominees?.length > 1 ? "" : "flex-end",
                              }}
                            >
                              {nominees?.length > 1 && (
                                <div className={Styles.buttonSectionLeft}>
                                  {nominees?.map((nominee: any, index: any) => (
                                    <div
                                      onClick={() => {
                                        handleNomineeEdit(index);
                                      }}
                                      className={Styles.nomineesAdded}
                                      style={{
                                        background:
                                          index === assignIndex
                                            ? "var(--ds-card)"
                                            : "",
                                        border:
                                          index === assignIndex
                                            ? "1px solid var(--ds-outline)"
                                            : "",
                                      }}
                                    >
                                      Nominee {index + 1}
                                    </div>
                                  ))}
                                </div>
                              )}
                              <div className={Styles.buttonSectionRight}>
                                <Button
                                  variant="text"
                                  sx={{
                                    color: "var(--ds-text-primary)",
                                    gap: "8px",
                                  }}
                                  onClick={() => {
                                    setAddNominee(false);
                                  }}
                                  className={Styles.backbutton}
                                >
                                  <KeyboardBackspaceIcon /> Back
                                </Button>
                                {nominees?.length !== 3 ? (
                                  <Button
                                    variant="text"
                                    className={Styles.addNomineeButton}
                                    onClick={() => {
                                      handleNomineeAdd(
                                        values,
                                        setFieldValue,
                                        setFieldTouched,
                                      );
                                      window.scrollTo(0, 0);
                                    }}
                                    disabled={
                                      percentageTotal >= 100 ||
                                      assignIndex === 2 ||
                                      Object.keys(errors).length > 0 ||
                                      Object.keys(touched).length === 0
                                    }
                                    id="nomineesAddNomineeButton"
                                    sx={{
                                      borderRadius: "8px",
                                      border: "1px solid var(--ds-outline)",
                                      color: "var(--ds-text-primary)",
                                      fontSize: "12px",
                                      visibility:
                                        assignIndex !== 2
                                          ? "visible"
                                          : "hidden",
                                    }}
                                    size="small"
                                  >
                                    Add Nominee {assignIndex + 2}
                                  </Button>
                                ) : (
                                  ""
                                )}
                                {percentageTotal !== 100 ? (
                                  <LoadingButton
                                    variant="contained"
                                    type="submit"
                                    // onClick={nomineeDetailsSubmit}
                                    disabled={
                                      values.nominees[0].nomineeFullName ===
                                        "" ||
                                      values.nominees[0].relationShip === "" ||
                                      percentageTotal !== 100 ||
                                      Object.keys(errors).length > 0
                                    }
                                    loading={loading}
                                    id="nomineesContinueButton"
                                    className={Styles.continue}
                                  >
                                    {percentageTotal > 100
                                      ? "Total Percentage of Share is > 100"
                                      : "Total Percentage of Share is < 100"}
                                  </LoadingButton>
                                ) : (
                                  <LoadingButton
                                    variant="contained"
                                    type="submit"
                                    // onClick={nomineeDetailsSubmit}

                                    disabled={
                                      values.nominees[0].nomineeFullName ===
                                        "" ||
                                      values.nominees[0].relationShip === "" ||
                                      percentageTotal !== 100 ||
                                      Object.keys(errors).length > 0
                                    }
                                    loading={loading}
                                    id="nomineesContinueButton"
                                    className={Styles.continue}
                                  >
                                    Continue
                                  </LoadingButton>
                                )}
                              </div>
                            </div>
                          </div>
                        </Form>
                      );
                    }}
                  </Formik>
                ) : (
                  <Stack height={"90vh"}>
                    <BackDrop />
                  </Stack>
                )}
              </>
            )}
          </div>
        </div>
      </div>

      <NomineeDeclarationModal
        openModal={openModal}
        handleClose={handleClose}
        handleSubmit={handleSkipNominee}
      />
    </>
  );
}
